module.exports = __webpack_public_path__ + "static/img/effectbannerbg4.4d562ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/effectbannerbg4.png
// module id = sxkh
// module chunks = 171